import React from "react"

function TimePickerIcon() {
  return (
    <span className="anticon anticon-datepicker ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16  "
      >
        <path
          d="M14.6673 7.99992C14.6673 11.6799 11.6807 14.6666 8.00065 14.6666C4.32065 14.6666 1.33398 11.6799 1.33398 7.99992C1.33398 4.31992 4.32065 1.33325 8.00065 1.33325C11.6807 1.33325 14.6673 4.31992 14.6673 7.99992Z"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4739 10.1199L8.40724 8.88659C8.04724 8.67326 7.75391 8.15992 7.75391 7.73992V5.00659"
          stroke="currentcolor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default TimePickerIcon
